import React from "react";
import { Container } from "reactstrap";

const AccessDenied = () => (
  <div className="page-content">
    <Container fluid>
      <div className="text-center mt-5">
        <h5>Nie masz uprawnien do tego zasobu.</h5>
      </div>
    </Container>
  </div>
);

export default AccessDenied;
